import { Controller } from "stimulus"

// Google renders reCAPTCHA in a fixed 304x78 iframe that ignores CSS width, so
// the only lever is a transform, and the wrapper has to carry the scaled height
// because a transform leaves layout size untouched.
//
// The widget's own label is already 14px, so scaling up past 1 would push it
// over the 14px cap: we only ever scale DOWN, to keep the widget inside narrow
// fields, and centre it when the field is wider than the widget.
const WIDGET_WIDTH = 304
const WIDGET_HEIGHT = 78
const MAX_SCALE = 1

export default class extends Controller {
  connect() {
    this.fit = this.fit.bind(this)

    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(this.fit)
      this.observer.observe(this.element)
    } else {
      window.addEventListener("resize", this.fit)
    }

    this.fit()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    } else {
      window.removeEventListener("resize", this.fit)
    }
  }

  fit() {
    const width = this.element.clientWidth
    // Setting the height below re-triggers the observer; only width matters.
    if (!width || width === this.lastWidth) return
    this.lastWidth = width

    const widget = this.element.querySelector(".g-recaptcha")
    if (!widget) return

    const scale = Math.min(MAX_SCALE, width / WIDGET_WIDTH)
    const offset = Math.max(0, (width - WIDGET_WIDTH * scale) / 2)
    widget.style.transformOrigin = "0 0"
    widget.style.transform = `translateX(${offset}px) scale(${scale})`

    // Only clip once we control the size — the no-JavaScript fallback keeps
    // the scrollable overflow it needs.
    this.element.style.overflow = "hidden"
    this.element.style.height = `${WIDGET_HEIGHT * scale}px`
  }
}
